import * as actions from './actions';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import apiTracking from '../../utils/tracking/apiTracking';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';

import * as actionChoiceActions from '../ActionChoiceCard/actions';
import * as callActions from '../Call/actions';
import * as checkRegistrationActions from '../CheckRegistration/actions';
import * as donationActions from '../Donation/actions';
import * as electionReminderActions from '../ElectionReminder/actions';
import * as findPollingStationActions from '../FindPollingStation/actions';
import * as linkActions from '../Link/actions';
import * as petitionActions from '../Petition/actions';
import * as pollActions from '../Poll/actions';
import * as quizActions from '../Quiz/actions';
import * as repStanceActions from '../RepStance/actions';
import * as radialSliderActions from '../RadialSlider/actions';
import * as sentimentPollActions from '../SentimentPoll/actions';
import * as tweetActions from '../Tweet/actions';
import * as videoActions from '../Video/actions';
import * as volunteerActions from '../Volunteer/actions';
import * as voteRegistrationActions from '../VoteRegistration/actions';

import { ActionTypes, CardTypes } from '../../utils/enums';
import { appendTrackingPixels } from '../../utils/thirdPartyTracking/helpers';

import { isPortrait } from '../../utils/size';

import {
    initFullStoryTracking,
    stopFullStoryTracking
} from '../../utils/thirdPartyTracking/fullstory';

const eventMappings = {};
eventMappings[actions.WIDGET_LOADED] = [trackWidgetLoaded];
eventMappings[actions.WIDGET_VISIBLE] = [trackWidgetVisible];
eventMappings[actions.ACTION_VISIBLE] = [trackActionVisible];
eventMappings[actions.WIDGET_ENGAGED] = [trackWidgetEngaged];
eventMappings[actions.ACTION_SHARED] = [trackShareAction];

eventMappings[actionChoiceActions.ACTION_CHOICE_BEGIN_ACTION] = [trackActionVisible];
eventMappings[actions.ACTION_INITIATED_LOCAL_REP] = [trackOpenAction];
eventMappings[actions.ACTION_INITIATED] = [trackOpenAction];
eventMappings[callActions.CALL_INITIATED] = [trackOpenAction];
eventMappings[checkRegistrationActions.CHECK_REGISTRATION_INITIATED] = [trackOpenAction];
eventMappings[donationActions.SELECT_AMOUNT] = [trackOpenAction];
eventMappings[electionReminderActions.ELECTION_REMINDER_INITIATED] = [trackOpenAction];
eventMappings[findPollingStationActions.FIND_POLLING_STATION_INITIATED] = [
    trackOpenAction
];
eventMappings[linkActions.LINK_INITIATED] = [trackOpenAction];
eventMappings[petitionActions.PETITION_INITIATED] = [trackOpenAction];
eventMappings[pollActions.POLL_INITIATED] = [trackOpenAction];
eventMappings[quizActions.QUIZ_INITIATED] = [trackOpenAction];
eventMappings[radialSliderActions.RADIAL_SLIDER_INITIATED] = [trackOpenAction];
eventMappings[repStanceActions.REP_STANCE_ACTION_UPDATED] = [trackActionUpdated];
eventMappings[repStanceActions.REP_STANCE_INITATED] = [trackOpenAction];
eventMappings[sentimentPollActions.SENTIMENT_POLL_INITIATED] = [trackOpenAction];
eventMappings[tweetActions.TWEET_INITIATED] = [trackOpenAction];
eventMappings[videoActions.VIDEO_INITIATED] = [trackOpenAction];
eventMappings[videoActions.VIDEO_PROGRESS] = [trackVideoProgressed];
eventMappings[volunteerActions.VOLUNTEER_INITIATED] = [trackOpenAction];
eventMappings[voteRegistrationActions.VOTE_REGISTRATION_INITIATED] = [trackOpenAction];

eventMappings[donationActions.DONATION_PAYMENT_PROVIDER_SELECTED] = [trackPaymentProviderSelected];

eventMappings[actions.SUBSCRIBE_SUCCESS] = [trackNewsletterSubscription];
eventMappings[actions.INCREMENT_NO_CARDS_VISITED] = [clearInitiatedActionIdentifiers];

let initiatedActionIdentifiers = [];
let seenActionIdentifiers = [];
let firstActionInitiated = false;
const subscriptionActionIdentifiers = [];

export default function trackWidget(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackWidgetLoaded(state) {
    const isMobile = isPortrait();
    if (isMobile) {
        appendTrackingPixels('widgetLoadedMobile', state);
    } else if (!isMobile) {
        appendTrackingPixels('widgetLoadedDesktop', state);
    }
    appendTrackingPixels('widgetLoaded', state);
}

function trackWidgetVisible(state) {
    const currCard = state.widget.cards[state.widget.activeAction.order - 1];

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_WIDGET_VISIBLE, {
        ...state.widget
    });

    apiTracking.trackWidgetVisible(state);
    if (currCard.type !== CardTypes.actionChoice) trackActionVisible(state);
    appendTrackingPixels('widgetImpression', state);
}

function trackWidgetEngaged(state) {
    if (state.widget.activeAction.type === ActionTypes.Donation) {
        appendTrackingPixels('donationInitiation', state);
    }
    apiTracking.trackWidgetEngaged(state);

    appendTrackingPixels('engaged', state);
}

function trackActionVisible(state) {
    if (state.widget.activeAction.type !== ActionTypes.RecordVideo) stopFullStoryTracking();

    if (state.widget.activeAction.type === ActionTypes.Poll) {
        appendTrackingPixels('pollImpression', state);
    }
    if (state.widget.activeAction.type === ActionTypes.SentimentPoll) {
        appendTrackingPixels('sentimentPollImpression', state);
    }
    if (state.widget.activeAction.type === ActionTypes.Quiz) {
        appendTrackingPixels('quizImpression', state);
    }

    const currCard = state.widget.cards[state.widget.activeAction.order - 1];
    state.widget.actions
        .filter(action => {
            if (currCard.type === CardTypes.actionChoice) {
                return action.identifier === state.widget.activeAction.identifier;
            } else {
                return true;
            }
        })
        .filter(
            action =>
                action.order === state.widget.activeAction.order &&
                !seenActionIdentifiers.includes(action.identifier)
        )
        .forEach(action => {
            seenActionIdentifiers.push(action.identifier);
            sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_SEEN, {
                ...state.widget,
                actions: null,
                action
            });

            apiTracking.trackActionVisible({
                ...state,
                widget: { ...state.widget, activeAction: action }
            });
        });
}

function trackShareAction(state) {
    const sharedWith = state.widget.lastSharedWith;

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_SHARED, {
        ...state.widget,
        action: state.widget.activeAction,
        sharedWith
    });

    apiTracking.trackSharedAction(state, sharedWith);
}

function trackVideoProgressed(state) {
    const progressFloat = state.video.progressFloat.toString();
    return apiTracking.trackVideoProgressed(state, progressFloat);
}
function trackActionUpdated(state) {
    return apiTracking.trackActionUpdated(state);
}

function trackPaymentProviderSelected(state) {
    return apiTracking.trackPaymentProviderSelected(
        state,
        state.donation.selectedPaymentProvider
    );
}

function trackOpenAction(state) {
    if (state.widget.activeAction.type === ActionTypes.RecordVideo) initFullStoryTracking();
    if (
        initiatedActionIdentifiers.find(
            identifier => identifier === state.widget.activeAction.identifier
        )
    ) {
        return;
    }

    initiatedActionIdentifiers.push(state.widget.activeAction.identifier);

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_INITIATED, {
        ...state.widget,
        action: state.widget.activeAction
    });

    apiTracking.trackOpenAction(state);

    if (!firstActionInitiated) appendTrackingPixels('initiated', state);

    firstActionInitiated = true;
}

function trackNewsletterSubscription(state) {
    if (
        subscriptionActionIdentifiers.find(
            identifier => identifier === state.widget.activeAction.identifier
        )
    ) {
        return;
    }

    subscriptionActionIdentifiers.push(state.widget.activeAction.identifier);

    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_NEWSLETTER_SUBSCRIPTION, {
        ...state.widget,
        action: state.widget.activeAction
    });

    apiTracking.trackNewsletterSubscription(state);
}

function clearInitiatedActionIdentifiers() {
    initiatedActionIdentifiers = [];
}
